const useStorage = (key: string, type = 'local') => {
  let storage = localStorage
  if (type === 'session') {
    storage = sessionStorage
  }
  const setItem = (storage: Storage) => {
    return (newValue: object | string | number) => {
      storage.setItem(key, JSON.stringify(newValue))
    }
  }
  const getItem = (key: string, storage: Storage) => {
    return () => {
      const value = storage.getItem(key)
      if (!value) {
        return null
      }
      try {
        return JSON.parse(value)
      } catch (error) {
        return value
      }
    }
  }
  const removeItem = (key: string, storage: Storage) => {
    return () => storage.removeItem(key)
  }

  return {
    getItem: getItem(key, storage),
    setItem: setItem(storage),
    removeItem: removeItem(key, storage)
  }
}

export default useStorage
